module.exports = __webpack_public_path__ + "img/cluster_education_100px_bluebox.49ff18c3.png";